import { createTheme } from '@mui/material/styles';

const customTheme = createTheme({
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          fontSize: '0.95rem',
          '& .MuiInputBase-root': {
            minHeight: 36,
            fontSize: '0.95rem',
          },
        },
      },
      defaultProps: {
        size: 'small',
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: '0.95rem',
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          fontSize: '0.95rem',
        },
      },
    },
  },
});

export default customTheme;
